import React from 'react'
import { AuthContext } from './auth-context'
import PropTypes from 'prop-types'
import SplashScreen from 'src/components/splash-screen/splash-screen'

const AuthConsumer = ({ children }) => {
  return (
    <AuthContext.Consumer>
      {(auth) => (auth.loading ? <SplashScreen /> : children)}
    </AuthContext.Consumer>
  )
}

export default AuthConsumer

AuthConsumer.propTypes = {
  children: PropTypes.node.isRequired,
}
